export function generalSelectors(state) {
    return state.general;
}